import * as React from "react";
import User from "../../_data/models/User";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import {Route} from "react-router";
import FollowListModalContainer from "../modal/containers/FollowListModalContainer";
import {Api} from "../../_helpers/api";
import {prettyPrintFollower} from "../../_helpers/utils";
import MyProfileBottomContainer from "../container/MyProfileBottomContainer";
import FollowContainer from "../../_widgets/follow/FollowContainer";
import MyProfileDetailsComponent from "./MyProfileDetailsComponent";
import UserRedirectContainer from "../../_widgets/user/UserRedirectContainer";
import {ResourceType} from "../../_helpers/data";
import {UsersRoutes} from "../../routes";

interface Props {
    currentUser: User;
    profile: User;
    loadingUser: boolean;
    viewFollowing: (id: number, name: string) => void;
    viewFollowers: (id: number, name: string) => void;
    showFollowing: boolean;
}

const FollowingModal = (props: any, showFollowing: boolean, profile: User) => {
    return <FollowListModalContainer {...{
        ...props,
        showFollowing: showFollowing,
        profile: profile
    }}/>
};


const MyProfileComponent = (props: Props) => {
    const {
        profile, currentUser, viewFollowing, viewFollowers, loadingUser
    } = props;

    if (!profile && loadingUser) {
        return (
            <div className="row expanded">
                <LoadingIndicatorComponent message="Loading user..."/>
            </div>
        );
    }
    else if (!profile && !loadingUser) {
        return (
            <div className="row expanded" style={{paddingLeft:'1rem', paddingTop:'1rem'}}>
                <h1>User not found. :(</h1>
            </div>
        );
    } else {
        return (
            <div className="row large-12 columns">
                <div className="callout mt-1">
                    <div className="row">
                        <div className="large-2 columns">
                            <div className="img-wrapper circle large">
                                <img src={profile.profilePicture()}/>
                            </div>
                        </div>
                        <div className="large-10 columns">
                            <div className="media-object">
                                <div className="media-object-section middle">
                                    <div className="text-group">
                                        <h5>{profile.username()}
                                            <small className="subheader">- {profile.displayProfession()}</small>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-right">
                                {currentUser && !(currentUser.id == profile.id) && profile.isProfessional &&
                                    <UserRedirectContainer className="button primary small" id={profile.id} element="a" type={ResourceType.message}>
                                        <i className="fa fa-envelope-o fa-fw"/>&nbsp; Message
                                    </UserRedirectContainer>
                                }
                                {!currentUser && profile.isProfessional &&
                                    <a href={UsersRoutes.sign_in()} className="button primary small">
                                        <i className="fa fa-envelope-o fa-fw"/>&nbsp; Message
                                    </a>
                                }
                                &emsp;
                                <FollowContainer model={profile} className="small"/>
                                {currentUser && (currentUser.id == profile.id) &&
                                    <a className=" button primary small pull-right" href={UsersRoutes.edit_profile(profile.id)}>
                                        <i className=" fa fa-edit"/>&nbsp; Edit Profile
                                    </a>
                                }
                            </div>
                            <MyProfileDetailsComponent profile={profile} currentUser={currentUser}/>
                        </div>
                    </div>
                    <ul className=" list-inline table justified">
                        <li className=" text-center">
                            {profile.followingCount > 0 &&
                            <a onClick={() => viewFollowing(profile.id, profile.name)}>
                                <b>{profile.followingCount}</b> Following
                            </a>
                            }
                            {profile.followingCount == 0 &&
                            <span>
                            <b>{profile.followingCount}</b> Following
                        </span>
                            }
                            <Route exact path={[Api.baseUrl, 'users', ':id', 'following'].join('/')}
                                   render={(props) => {
                                       return FollowingModal(props, true, profile);
                                   }}/>
                            <Route exact path={['/:str', 'following'].join('/')} render={(props) => {
                                return FollowingModal(props, true, profile);
                            }}/>
                        </li>
                        <li className=" text-center">
                            {profile.followersCount > 0 &&
                            <a onClick={() => viewFollowers(profile.id, profile.name)}>
                                <b>{profile.followersCount}</b> {prettyPrintFollower(profile.followersCount)}
                            </a>
                            }
                            {profile.followersCount == 0 &&
                            <span>
                            <b>{profile.followersCount}</b> {prettyPrintFollower(profile.followersCount)}
                        </span>
                            }
                            <Route exact path={[Api.baseUrl, 'users', ':id', 'followers'].join('/')}
                                   render={(props) => {
                                       return FollowingModal(props, false, profile);
                                   }}/>
                            <Route exact path={['/:str', 'followers'].join('/')} render={(props) => {
                                return FollowingModal(props, false, profile);
                            }}/>
                        </li>
                    </ul>
                    <MyProfileBottomContainer profile={profile}/>
                </div>
            </div>
        );
    }
};

export default MyProfileComponent;


// WEBPACK FOOTER //
// ./app/client/user/components/MyProfileComponent.tsx